// Realm removed - using custom API auth instead
// This file kept for backward compatibility but no longer imports Realm

export const REALM_APP_ID = "mainlistapp-kqoki"; // Legacy - not used
export const app = null; // Deprecated - use API auth instead
export default null;